import { Component } from '@angular/core';

/* Export containers */
// export * from './containers/'
// export * from './containers/user-details.component';
/* Export components */
export * from './components/your-options-calculation/your-options-calculation.component';
export * from './components/quote-calculation-result/quote-calculation-result';
export * from './components/quote-variants/quote-variants.component';
export * from './components/quote-playback/quote-playback.component';
export * from './components/product-quote/product-quote/product-quote.component';
export * from './components/product-quote/selected-product-quote/selected-product-quote.component';
export * from './components/product-quote/corp-product-quote/corp-product-quote.component';
export * from './components/product-quote/ftrp-product-quote/ftrp-product-quote.component';
export * from './components/product-quote/partial-product-quote/partial-product-quote.component';
export * from './components/product-quote/product-quote-comparison/product-quote-comparison.component';
export * from './components/your-saved-quote/your-save-quote/your-save-quote.component';
export * from './components/cashout-retirement-plan/cashout-retirement-plan.component';
export * from './components/product-quote/gmp-annuity-quote/gmp-annuity-quote.component';
/* Export config */
export * from './config/user-data.config';
export * from './components/user-registration/user-registration.component';

/* Export module */
export * from './containers/quote-calculation.module';


